import { Box } from '@wix/design-system';
import React from 'react';

type BackgroundProps = {
  children: React.ReactNode;
  backgroundColor?: string;
};

export const Background = ({ children, backgroundColor }: BackgroundProps) => {
  return (
    <Box
      backgroundColor={backgroundColor ?? 'white'}
      borderRadius="16px"
      direction="vertical"
      width="100%"
      paddingTop="30px"
      paddingBottom="SP10"
      paddingLeft="SP2"
      paddingRight="SP2"
      boxSizing="border-box"
    >
      {children}
    </Box>
  );
};
